module.exports = __webpack_public_path__ + "img/vx.c2e353ed.png";